import { useQuery } from "@tanstack/react-query";

import { getReportingActors } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import type { ReportingPeriod } from "Reporting/Components/PeriodSelector";
import { REPORTING_QUERY_KEYS } from "./queryKeys";

export function useReportingActorsQuery(period?: ReportingPeriod) {
  return useQuery({
    queryKey: [...REPORTING_QUERY_KEYS.actors(), period ?? "all"],
    queryFn: processResponse(() => getReportingActors()),
    staleTime: 5 * 60 * 1000,
  });
}
